<template>
    <div>
        <h6 class="">{{ $t(`${configId}.report.title`) }}</h6>
        <hr class="mt-2" />
        <div class="row">
            <div class="col-sm-3">
                <MaterialSelect
                    :disabled="disabled"
                    class="city-form-group city-bg"
                    id="input-report"
                    name="report"
                    label="name"
                    :filterable="true"
                    :options="lists.onoff"
                    v-model.trim="form.status"
                    :reduce="option => option.code"
                    v-validate="'required'"
                    :inputClasses="[{'is-invalid': fnHasError('report', vScope) }]"
                    :error=" fnFirstError('report', vScope)"
                    :helpText="helpReport.status">
                    {{ $t(`${configId}.report.model.status`) }}
                </MaterialSelect>
            </div>
            <div class="col-sm-9">
                <div class="form-group">
                    <MaterialInput
                        :readonly="disabled"
                        :disabled="disabled"
                        type="text"
                        class="city-form-group city-bg"
                        id="input-report-title"
                        name="report-title"
                        v-model.trim="form.title"
                        v-validate="{required: form.status == 1, 'min':3}"
                        :inputClasses="[{'is-invalid': fnHasError('report-title', vScope) }]"
                        :error=" fnFirstError('report-title', vScope)">
                        {{ $t(`${configId}.report.model.title`) }}
                    </MaterialInput>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ManagePrintElementMixin from '../mixins/ManagePrintElementMixin';

export default {
    name: 'ConfigReportGeneral',
    mixins: [
        ManagePrintElementMixin
    ],
    props: {
        reportHelp: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            form: {
                status: 0,
                title: null,
            },
        }
    },
    computed: {
        helpReport() {
            return {status: this.reportHelp ?? this.$t(`${this.configId}.report.help.status`)};
        },
    },
}
</script>